export interface Usuario {
    username: string,
    token: string,
    nombre?: string,
    direccion?: string,
    telefonos?: string,
    email?: string,
    ciudad?: number,
    dni?: number,
    fechaNacimiento?: string,
    sucursal?: number,
    password?: string,
    clienteol?: number,
    empresa?: number,
    listamayorista?: number,
    listareducmayorista?: string,
    sucursalEmpresa?: number;
    sucursalNombre?: string,
    codigopostal? : string,
    ocultarPrecios? : string,
    tipoUsuario?: string
}
